// 百度
export default [
  {
    path: '/baiduIndex',
    name: 'baiduIndex',
    meta: { title: '百度店铺兑换' },
    component: () => import('@/views/baidu/index')
  },
  {
    path: '/baiduList',
    name: 'baiduList',
    meta: { title: '百度店铺兑换' },
    component: () => import('@/views/baidu/list')
  },
  // 百度优选新店-联盈通达企业店T1006201
  {
    path: '/baidulytd',
    name: 'baidulytd',
    meta: { title: '百度店铺兑换' },
    component: () => import('@/views/baidulytd/index')
  },
  {
    path: '/baidulytdList',
    name: 'baidulytdList',
    meta: { title: '百度店铺兑换' },
    component: () => import('@/views/baidulytd/list')
  }
]
